import { MenuItem } from "@mui/material"

/**
 * A custom menu item component for use in the `ExtendedSelect` dropdown.
 * Renders a `MenuItem` with a specified value and option label.
 *
 * @param {Object} props - The props for the `ExtendedSelectMenuItem` component.
 * @param {string} props.value - The value associated with the menu item.
 * @param {string} props.option - The label or display text for the menu item.
 * @param {Object} [props] - Any additional props that are passed down to the `MenuItem`.
 *
 * @returns {JSX.Element} A `MenuItem` element with the provided value and option text.
 */
export function ExtendedSelectMenuItem({ value, option, ...props }) {
    return (
        <MenuItem value={value} {...props}>
            {option}
        </MenuItem>
    )
}
